import { useHealthlinkCredentials } from "features/healthlink/hooks/useHealthlinkCredentials";
import { useHealthlinkPractice } from "features/healthlink/hooks/useHealthlinkPractice";

import { HealthlinkDoctorDetailsModal } from "./HealthlinkDoctorDetailsModal/HealthlinkDoctorDetailsModal";
import { HealthLinkPracticeModal } from "./HealthLinkPracticeModal/HealthLinkPracticeModal";

export const HealthlinkCredentialsModal = () => {
  const { data: healthlinkPractice } = useHealthlinkPractice();
  const { data: healthlinkCredentials } = useHealthlinkCredentials();

  if (!healthlinkPractice) {
    return <HealthLinkPracticeModal />;
  }

  if (
    !Array.isArray(healthlinkCredentials) ||
    healthlinkCredentials.length === 0
  ) {
    return <HealthlinkDoctorDetailsModal />;
  }

  return null;
};
